import React from 'react';

type FilterOption = {
  label: string;
  key: string;
  type: 'checkbox' | 'range';
  options?: string[];
  min?: number;
  max?: number;
};

// Function to return filter labels
export const getFilterLabels = (): FilterOption[] => {
  return [
    {
      key: 'totalScore',
      label: 'Total Score',
      type: 'range',
      min: 0,
      max: 100,
    },
    {
      key: 'technicalSkill',
      label: 'Technical Skill',
      type: 'range',
      min: 0,
      max: 100,
    },
    {
      key: 'roleExperience',
      label: 'Role Experience',
      type: 'range',
      min: 0,
      max: 100,
    },
    {
      key: 'industrySkills',
      label: 'Industry Skills',
      type: 'range',
      min: 0,
      max: 100,
    },
    {
      key: 'productKnowledge',
      label: 'Product Knowledge',
      type: 'range',
      min: 0,
      max: 100,
    },
    {
      key: 'leadership',
      label: 'Leadership',
      type: 'range',
      min: 0,
      max: 100,
    },
  ];
};
